var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationCanvasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H0V24H20V8H12V0ZM2 2H10V4H2V2ZM10 6H2V8H10V6ZM14 22H12L8 15V22H6V12H8.21167L12 18.5V12H14V22ZM16 4L13 1V7H19L16 4Z",
    fill: "#006AF5",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationCanvasIcon);
export default __webpack_public_path__ + "static/media/AnnotationCanvasIcon.f76a44edf4a6ee6b53f5cb31560a3bfa.svg";
export { ForwardRef as ReactComponent };